import { render, staticRenderFns } from "./PremiumUsers.vue?vue&type=template&id=da454288&"
import script from "./PremiumUsers.vue?vue&type=script&lang=js&"
export * from "./PremiumUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports